'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoreTags = exports.getCoreXTags = exports.getUserTags = exports.getUserName = void 0;
var session_1 = require("../session/session");
/**
 * Tries to get an user name, either with the provided one or
 * with the one from the current session. If neither is available
 * it throws an error
 * @param method name of the method to include in the exception message
 *               if an error happens
 * @param userName possibly undefined user name
 */
function getUserName(method, userName) {
    if (userName === undefined) {
        var user = session_1.session.getUser();
        if (user) {
            return user.userName;
        }
        else {
            throw new Error('Username not specified and session not active in method ' +
                method);
        }
    }
    else {
        return userName;
    }
}
exports.getUserName = getUserName;
/**
 * Get the websocket subscription tags for the given user
 */
function getUserTags(user, isCoreX, brand) {
    if (isCoreX) {
        return getCoreXTags(user, brand);
    }
    else {
        return getCoreTags(user);
    }
}
exports.getUserTags = getUserTags;
function getCoreXTags(user, brand) {
    var tags = [
        "user:" + user.userName,
        "user_profile_id:" + user.id,
        "lang:" + (user.lang || 'en'),
        "site:" + brand,
    ];
    addCommonUserTags(user, tags);
    return tags;
}
exports.getCoreXTags = getCoreXTags;
function getCoreTags(user) {
    var tags = ["user:" + user.userName];
    addCommonUserTags(user, tags);
    return tags;
}
exports.getCoreTags = getCoreTags;
/**
 * Add common user tags between Core and CoreX, mainly used for messaging
 * @param user The user object
 * @param tags Array to push common tag into (in place)
 */
function addCommonUserTags(user, tags) {
    tags.push("segment:" + (user.segment || 0));
    if (user.country) {
        tags.push("country:" + user.country);
    }
    if (user.lang) {
        tags.push("lang:" + user.lang);
    }
    if (user.affiliate) {
        tags.push("affiliate:" + user.affiliate);
    }
    if (user.location) {
        tags.push("location:" + user.location);
    }
    if (user.roles && user.roles.length) {
        user.roles.forEach(function (role) { return tags.push("role:" + role); });
    }
    if (!isNaN(user.depositCount)) {
        tags.push("depositCount:" + user.depositCount);
    }
    if (typeof user.notOnSiteMarketing === 'boolean') {
        tags.push("notOnSiteMarketing:" + user.notOnSiteMarketing);
    }
}
